import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { TableColumn } from '@mynexus/mynexus-ui-lib';
import { DocumentSourceType } from '@core/enumeration';
import { DocumentsPAC, UploadFile } from '@shared/model';


@Component({
  selector: 'selected-document',
  templateUrl: './selected-document.component.html',
  styleUrls: ['./selected-document.component.scss'],
  standalone: false
})
export class SelectedDocumentComponent implements OnInit{
  @Input() uploadedFiles: UploadFile[] | DocumentsPAC[] = [];
  @Input() viewMode = false;

  @Output() deleteItem = new EventEmitter<number>();

  readonly DocumentSourceType = DocumentSourceType;

  cols!: TableColumn[];
  hasExpandableRows = false;

  ngOnInit(): void {
    this.hasExpandableRows =
      this.uploadedFiles?.length > 0
      && this.uploadedFiles.some(file => file.documentSource === DocumentSourceType.EHR);

    this.cols = [];

    if (this.hasExpandableRows) {
      this.cols.push(
        new TableColumn('', 'canExpand', '3rem')
      );
    }

    this.cols.push(...[
      new TableColumn('File Name', 'documentFileName', '15rem', ''),
      new TableColumn('Source', 'documentSource', '15rem'),
      new TableColumn('Document Type', 'documentTypes', '15rem'),
      new TableColumn('Description', 'description', '9rem'),
      new TableColumn('File Size', 'fileMetaData.size', '3rem')
    ]);

    if (!this.viewMode) {
      this.cols.push(new TableColumn('', '', '3rem'));
    }
  }

  canExpandRow(document: UploadFile | DocumentsPAC): boolean {
    return document.documentSource === DocumentSourceType.EHR;
  }

  onDeleteItem(index: number): void {
    this.deleteItem.emit(index);
  }
}
